exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".displayAll .homeworkContainer.homeworkOnly.homework-hint-1,.homework-hint-1{border:1px dashed red}.displayAll .homeworkContainer.homeworkOnly.homework-hint-2,.homework-hint-2{border:1px dashed lime}.displayAll .homeworkContainer.homeworkOnly.homework-hint-3,.homework-hint-3{border:1px dashed blue}.displayAll .homeworkContainer.homeworkOnly.homework-hint-4,.homework-hint-4{border:1px dashed #ff0}.displayAll .homeworkContainer.homeworkOnly.homework-hint-5,.homework-hint-5{border:1px dashed cyan}.displayAll .homeworkContainer.homeworkOnly.homework-hint-6,.homework-hint-6{border:1px dashed #f0f}", ""]);

// exports
